import { BehaviorSubject, Subject } from 'rxjs';
import { adapterId } from './adapter-id';
import { UniversalBrowserExtensionAdapter } from './adapters/universal-browser-extension-adapter';
import { GlobalDataAdapter } from './global-data-adapter';
import { getInjectedProviderDetail } from './injected-provider-detail';
export class ConnectWalletEmbeddedController {
    get isConnected() {
        return true;
    }
    get connectedWalletInfo() {
        return this.currentActiveAdapter?.info ?? null;
    }
    constructor(config) {
        this.config = config;
        this.currentActiveAdapter = null;
        this.activeAdapters = new Map();
        this.data = new GlobalDataAdapter(this);
        this.update$ = new Subject();
        this.supportedWallets$ = new BehaviorSubject([]);
    }
    async init() {
        if (!this.config.walletProvider)
            return;
        const injectedProviderDetail = await getInjectedProviderDetail(this.config.walletProvider);
        this.supportedWallets$.next([injectedProviderDetail.info]);
        const id = adapterId(injectedProviderDetail.info);
        const adapter = new UniversalBrowserExtensionAdapter(injectedProviderDetail);
        this.activeAdapters.set(id, adapter);
        await adapter.connect(this.config.chainId);
        this.currentActiveAdapter = adapter;
        this.update$.next();
    }
    async getSupportedWallets() {
        const injectedProviderDetail = await getInjectedProviderDetail(this.config.walletProvider);
        return [injectedProviderDetail.info];
    }
    async writeContract(params) {
        if (!this.currentActiveAdapter || !this.currentActiveAdapter.client) {
            throw new Error('Wallet not connected');
        }
        return await this.currentActiveAdapter.writeContract(params);
    }
    async signTypedData(typeData) {
        if (!this.currentActiveAdapter || !this.currentActiveAdapter.client) {
            throw new Error('Wallet not connected');
        }
        return await this.currentActiveAdapter.signTypedData(typeData);
    }
    setChainIds(chainIds) {
        this.data.setChainIds(chainIds);
    }
    connect() {
        throw new Error('Method not implemented.');
    }
    addConnection() {
        throw new Error('Method not implemented.');
    }
    disconnect() {
        throw new Error('Method not implemented.');
    }
    getDataAdapter() {
        throw new Error('Method not implemented.');
    }
    setActiveAddress() {
        throw new Error('Method not implemented.');
    }
    connectionUriLink() {
        return this.getActiveAdapter().connectionUriLink();
    }
    async isSupportConnectionUriLink(info) {
        const id = adapterId(info);
        const adapter = this.activeAdapters.get(id);
        return adapter?.isSupportConnectionUriLink() ?? false;
    }
    getActiveAdapter() {
        if (!this.currentActiveAdapter) {
            throw new Error('call init before');
        }
        return this.currentActiveAdapter;
    }
}
//# sourceMappingURL=connect-wallet-embedded-controller.js.map